import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import RealEstatesSection from '../components/realEstate/RealEstatesSection';
import Footer from '../Footer';
import Loader from '../utilities/Loader';
import { getRealEstates } from '../slices/realEstateSlice';
import { getRealEstateTypes } from '../slices/realEstateTypeSlice';
import WhatsAppButton from '../utilities/WhatsAppButton';
import NavigationBar from '../NavigationBar';
import { useAuth0 } from '@auth0/auth0-react';
import { useLocation } from 'react-router-dom';
import { scrollToRealEstatesContent } from '../utilities/scrollToRealEstatesContent';

export default function SalesPage() {
  const { isLoading } = useAuth0();
  const realEstates = useSelector((state) => state.realEstates.data);
  const realEstatesStatus = useSelector((state) => state.realEstates.status);
  const realEstateTypes = useSelector((state) => state.realEstateTypes.data);
  const realEstateTypesStatus = useSelector(
    (state) => state.realEstateTypes.status
  );
  const dispatch = useDispatch();
  const location = useLocation();
  const shouldScrollToContent = Boolean(location.state?.scrollToContent);

  useEffect(() => {
    if (realEstatesStatus === 'idle' || realEstateTypesStatus === 'idle') {
      dispatch(getRealEstates());
      dispatch(getRealEstateTypes());
    }
  }, [dispatch, realEstatesStatus, realEstateTypesStatus]);

  React.useEffect(() => {
    if (!shouldScrollToContent) {
      return;
    }

    if (
      realEstatesStatus !== 'succeeded' ||
      realEstateTypesStatus !== 'succeeded' ||
      isLoading
    ) {
      return;
    }

    const animationFrameId = window.requestAnimationFrame(() => {
      scrollToRealEstatesContent('auto');
    });

    return () => {
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [
    shouldScrollToContent,
    realEstatesStatus,
    realEstateTypesStatus,
    isLoading,
  ]);

  return (
    <>
      {realEstatesStatus !== 'succeeded' ||
      realEstateTypesStatus !== 'succeeded' ||
      isLoading ? (
        <Loader />
      ) : (
        <>
          <NavigationBar />
          <RealEstatesSection
            realEstates={realEstates}
            realEstateTypes={realEstateTypes}
          />
          <WhatsAppButton />
          <Footer />
        </>
      )}
    </>
  );
}
